export const isURL = (str: string): boolean => (str.startsWith('http') || str.startsWith('www')) && str.indexOf(' ') === -1 && str.indexOf('\n') === -1
